const keyFor = (email) =>
  `trusted_device:${String(email)
    .trim()
    .toLowerCase()}`;

export function getTrustedDeviceToken(email) {
  try {
    return localStorage.getItem(keyFor(email));
  } catch (err) {
    return null;
  }
}

export function setTrustedDeviceToken(email, token) {
  try {
    localStorage.setItem(keyFor(email), token);
  } catch (err) {
    // Storage unavailable: the device just won't be remembered.
  }
}

export function clearTrustedDeviceToken(email) {
  try {
    localStorage.removeItem(keyFor(email));
  } catch (err) {
    // Nothing to clear.
  }
}
